import { render, staticRenderFns } from "./PresentacionActionButtonsSaf.vue?vue&type=template&id=4953a7c5&"
import script from "./PresentacionActionButtonsSaf.vue?vue&type=script&lang=js&"
export * from "./PresentacionActionButtonsSaf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardActions,
})
